import React from 'react'
import Yup from '../../../helpers/custom-yup.js'
import TicketSaleSelectors from '../../../ducks/ticket-sale/ticket-sale.selectors'
import BusSeatSelectionSelectors from '../../../selectors/bus-seat-selection.selectors'
import { connect } from 'react-redux'
import { Formik, Form } from 'formik'
import PaymentFields, {
	paymentFieldsYupSchema,
	paymentMuvicardFieldsYupSchema,
	paymentMuvicardOneClickYupSchema,
	paymentFieldsInitialValues
} from '../../../components/form-components/payment-fields/payment-fields.component'
import TicketSaleService from './../../../services/ticket-sale.service'
import { PAYMENT_METHODS } from '../../../constants'
class PaymentDataComponent extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			bankSlipParameters: {}
		}
	}

	shouldComponentUpdate(nextProps) {
		if (this.props.totalValue == nextProps.totalValue && this.props.paymentMethod == nextProps.paymentMethod) {
			return false
		}

		return true
	}

	async componentDidMount() {
		this.props.getFormRef(this.refs.form)
		await TicketSaleService.getBankSlipParameters().then(
			({ success, data }) => {
				if (success) {
					this.setState({ bankSlipParameters: data })
				}
			}
		)
	}

	renderFormik = props => {
		const { busCompany } = this.props

		const { bankSlipParameters } = this.state

		const isNotPartnerCompany = !(
			busCompany == 'Planalto' ||
			busCompany == 'Muvibus' ||
			busCompany == 'Planalto2'
		)

		return (
			<Form noValidate>
				<PaymentFields
					{...props}
					noOnlineDebt
					isNotPartnerCompany={isNotPartnerCompany}
					noBankSlip={false}
					orderValue={this.props.totalValue}
					onCompleteCpf={cpf => {
						this.props.handleCompleteCpf(cpf)
					}}
					bankSlipParameters={bankSlipParameters}
				/>
			</Form>
		)
	}

	render() {
		const schema = Yup.object().shape(paymentFieldsYupSchema)
		const muvischema = Yup.object().shape(paymentMuvicardFieldsYupSchema)
		const oneClickMuviSchema = Yup.object().shape(
			paymentMuvicardOneClickYupSchema
		)
		const initialValues = paymentFieldsInitialValues({ installments: true })
		const { paymentMethod, user } = this.props

		let schemaCard = ''

		if (paymentMethod == PAYMENT_METHODS.MUVICARD) {
			if (user && user.muvicardData && user.muvicardData.oneClickBuy) {
				schemaCard = oneClickMuviSchema
			} else {
				schemaCard = muvischema
			}
		} else {
			schemaCard = schema
		}

		return (
			<React.Fragment>
				<Formik
					ref="form"
					validationSchema={schemaCard}
					render={this.renderFormik}
					initialValues={initialValues}
					onSubmit={this.props.onSubmit}
				/>
			</React.Fragment>
		)
	}
}

const mapStateToProps = store => ({
	user: store.user,
	discountLabel: store.ticketSale.discountLabel,
	discountValue: store.ticketSale.discountValue,
	discountPercent: store.ticketSale.discountPercent,
	tripPriceGoing: TicketSaleSelectors.getTripPriceGoing(store),
	totalPointsOnTicketSale: store.ticketSale.totalPointsOnTicketSale,
	discountPercentage: store.ticketSale.discountCoupon.discountPercentage,
	tripPriceReturn: TicketSaleSelectors.getTripPriceReturn(store),
	serviceCharge: TicketSaleSelectors.getServiceChargeValue(store),
	selectedBusSeatsGoing: BusSeatSelectionSelectors.getSelectedBusSeatsGoing(
		store.busSeatSelection
	),
	selectedBusSeatsReturn: BusSeatSelectionSelectors.getSelectedBusSeatsReturn(
		store.busSeatSelection
	),
	paymentMethod: store.ticketSale.paymentMethod,
	selectedPoltonasIda: BusSeatSelectionSelectors.getSelectedViagemIda(
		store.busSeatSelection
	),
	calculatedValues: TicketSaleSelectors.getCalculatedValues(store)
})

const PaymentData = connect(mapStateToProps, null)(PaymentDataComponent)

export default PaymentData
